import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsBaseApi {
  constructor(private _http: HttpClient) { }

  settings$(clientId: string) {
    // TODO: interface
    return this._http.get<any>(
      `/api/client/${clientId}/settings`
    );
  }

  stackTypeDetail$(clientId: string, stackTypeId: string) {
    return this._http.get<any>(
      `/api/client/${clientId}/settings/stack-type/${stackTypeId}`
    );
  }

  countryList$() {
    return this._http.get<any>(
      `/api/settings/country-list`
    )
  }
}
